/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum Status {
  OK = "OK",
  FAIL = "FAIL",
}

export interface ChangePasswordResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
}

export interface ChangePasswordRequest {
  hash?: string;
  newPassword?: string;
  confirmNewPassword?: string;
}

export interface LoginResponse {
  userLoggedIn?: boolean;
  chooseClient?: boolean;
  /** @format int32 */
  returnCode?: number;
  apiToken?: string;
  admin?: boolean;
}

export interface ResponseLoginResponse {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: LoginResponse;
  requestId?: string;
}

export interface ResponseObject {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: object;
  requestId?: string;
}

export interface CreateUserRequest {
  hash?: string;
  newPassword?: string;
  confirmNewPassword?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  language?: string;
}

export interface ResponseUserDataDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: UserDataDto;
  requestId?: string;
}

export interface UserDataDto {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  username?: string;
  email?: string;
}

export interface InvitedUserDto {
  newUser?: boolean;
  userName?: string;
  firstName?: string;
  lastName?: string;
  language?: string;
}

export interface ResponseInvitedUserDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: InvitedUserDto;
  requestId?: string;
}

export interface CiamLoginRequest {
  code?: string;
}

export interface LoginRequest {
  userName?: string;
  password?: string;
}

export interface ResponseString {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: string;
  requestId?: string;
}

export interface ResetPasswordRequest {
  email?: string;
}

export interface AppStatusResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  serverStatus?: Status;
  databaseStatus?: Status;
}

export interface ResponseSystemInfoDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: SystemInfoDto;
  requestId?: string;
}

export interface SystemInfoDto {
  currentSystem?: string;
  commitSha?: string;
  buildDate?: string;
  releaseVersion?: string;
}
